import script from "./UpsertProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./UpsertProduct.vue?vue&type=script&setup=true&lang=js"

import "./UpsertProduct.vue?vue&type=style&index=0&id=77444697&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77444697"]])

export default __exports__